import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {rolesTableReady,rowsPerPageState,searchTextState,paginationState,rolesIdForAction} from '../redux/roles'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/rolesTable.css'

import CollapsibleRow from './CollapsibleRow'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(rolesData) {
    let array = []
    if (rolesData && rolesData.data && rolesData.data.list) {
        array = rolesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.type =lineData.type ? lineData.type : "NA"
            newLineData.remarks =lineData.remarks ? lineData.remarks : "NA"

            let role_privileges = []
            
            for (let j = 0; j < lineData.role_privileges.length; j++) {
                role_privileges[j]={
                    "role_privileges_id":lineData.role_privileges[j].id,
                    "privilege_name":lineData.role_privileges[j].privilege.name,
                    "api_access":lineData.role_privileges[j].privilege.api_access,
                    "app_access":lineData.role_privileges[j].privilege.app_access
                    }                    
            }   
            newLineData.role_privileges=role_privileges;

            newArray[i] = newLineData
        }
    }
    return newArray
}


class RolesTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            rolesData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(rolesTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ROLES_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getRolesData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getRolesData = () => {
        apiService.getRolesData()
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.roles && this.props.roles.previousPaginationValue) {
                            pageNo = this.props.roles.previousPaginationValue
                        }
                        this.setState({
                            rolesData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(rolesTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(rolesTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.roles && this.props.roles.previousRowsPerPageValue) {
            value = this.props.roles.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">


{(() =>{

    if(Helpers.checkPrivileges("/dashboard/roles/addEdit",this.props.user)){
        return(
                    
                   
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.dispatch(rolesIdForAction(null))
                                this.props.history.push("/dashboard/roles/addEdit")
                            }}>
                            Add
                        </button>
                    </div>

            )
        }
})()}

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    
     
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.rolesData.length>=(this.props.roles.previousPaginationValue*this.props.roles.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.roles.previousPaginationValue*this.props.roles.previousRowsPerPageValue)-this.props.roles.previousRowsPerPageValue+1} to {this.props.roles.previousPaginationValue*this.props.roles.previousRowsPerPageValue} of {this.state.rolesData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.roles.previousPaginationValue*this.props.roles.previousRowsPerPageValue)-this.props.roles.previousRowsPerPageValue+1} to {this.state.rolesData.length} of {this.state.rolesData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }


    getFilteredBrandList = () => {
       
        this.props.dispatch(rolesTableReady(false))
        this.resetSearchAndPagination()
        this.getRolesData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getRolesData()
        this.props.dispatch(rolesTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }




    actionButtonsCreator = (cell, row) => {
        let editRoles =""


    if(Helpers.checkPrivileges("/dashboard/roles/addEdit",this.props.user)){
        
            editRoles=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editRoles(row)
                }}>
                Edit
            </button>

        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editRoles}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.roles && this.props.roles.previousPaginationValue
            && this.props.roles.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editRoles = (row) => {
        if (row && row.id) {
            this.props.dispatch(rolesIdForAction(row.id))
            this.props.history.push("/dashboard/roles/addEdit")
        } else {
            this.dialog.show({
                title: "Privilege Identification number not found",
                body: 'Privilege id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


     expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <CollapsibleRow row={row} row_id={row_id} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }

    render() {
        let sizeperPage = 15

        if (this.props.roles && this.props.roles.previousRowsPerPageValue) {
            sizeperPage = this.props.roles.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="roles-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.rolesData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent,
                        columnWidth: 30
                    }}
                     >
  {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="name"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="type"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Type
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="remarks"
                        //width="90"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Remarks
                    </TableHeaderColumn>
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        roles: state.roles
    }
}

export default connect(mapStateToProps)(withRouter(RolesTable))


// WEBPACK FOOTER //
// ./src/modules/Roles/Components/RolesTable.js